// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fK","advertDetailHeaderPrice__value":"c-m_fL","advertDetailHeaderPrice__label":"c-m_fM"};